import type { EventOccurrenceViewModel } from '@trinnvis/dabih-api-client';
import { LocalDate } from '../../../utilities/local-date';
import { sortBy } from 'lodash';

export function findClosestInstance(
  occurrences: EventOccurrenceViewModel[],
  date: LocalDate,
): EventOccurrenceViewModel {
  const datedOccurrences = occurrences.filter((o) => o.date !== undefined);
  const sortedDatedOccurrences = sortBy(datedOccurrences, (o) => LocalDate.fromString(o.date));
  const previous = sortedDatedOccurrences.findLast((o) => LocalDate.fromString(o.date).isSameOrBefore(date));
  if (previous !== undefined) return previous;
  const next = sortedDatedOccurrences.find((o) => LocalDate.fromString(o.date).isAfter(date));
  if (next !== undefined) return next;
  const undated = occurrences.find((o) => o.date === undefined);
  if (undated === undefined) {
    throw new Error('No occurrence found in EventModel');
  }
  return undated;
}
